import { Box, Button, Stack, Typography } from '@presov.sk/presov-ui-react';
import React from 'react';
import { Link } from 'react-router';

type Props = {
  /** vysvetlivka vľavo - čo zoznam nad ňou (ne)obsahuje */
  hint: string;
  action?: { label: string; href: string };
};

/**
 * Pätička sekcie profilu: vysvetlivka vľavo, jedna neutrálna akcia vpravo.
 *
 * Sedí **na spodnej hrane karty**, nie v jej odsadení - preto záporné okraje.
 * Odsadenie obsahu dáva karte stránka ([[ProfilePage]]) jedným miestom pre
 * všetky sekcie; pás, ktorý má ísť od hrany po hranu, sa z neho musí vymaniť
 * sám. Hodnoty sú tie isté, aké karta pridáva (`p: 2`).
 */
const SectionFooter: React.FC<Props> = ({ hint, action }) => (
  <Stack
    direction='row'
    alignItems='center'
    gap={1.5}
    sx={{
      flex: 'none',
      mx: -2,
      mb: -2,
      px: 2,
      py: 1.5,
      minHeight: 61,
      bgcolor: 'grey.50',
      borderTop: '1px solid',
      borderColor: 'divider',
    }}
  >
    <Typography variant='caption' color='text.secondary' sx={{ flex: 1 }}>
      {hint}
    </Typography>

    {!!action && (
      <Box sx={{ flex: 'none' }}>
        <Button
          size='small'
          variant='outline'
          component={Link}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          {...({ to: action.href } as any)} // LinkProps
        >
          {action.label}
        </Button>
      </Box>
    )}
  </Stack>
);

export default SectionFooter;
